import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BodyContainer from '../ui/BodyContainer';
import { Grid, Paper } from '@material-ui/core';
import { backArrow } from '../ui/icons';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => {});

// const classes = useStyles();

const ContactInfo = () => {
  const history = useHistory();

  const handleBackButton = () => {
    history.goBack();
  };

  return (
    <BodyContainer title='Contact Info' icon={backArrow(handleBackButton)}>
      <Paper
        style={{
          backgroundColor: '#fff',
          padding: '15px',
          width: '100%',
          height: '200px',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <p
            style={{
              marginBottom: '30px',
              fontWeight: '700',
              fontSize: '18px',
            }}
          >
            If you want to know more about 2Gathers and for scheduling a demo,
            <br />
            please contact 2Gathers team at:
          </p>
          <p>
            <span
              style={{
                fontWeight: '700',
                fontSize: '15px',
                marginRight: '5px',
              }}
            >
              Phone:
            </span>
            +1-404-590-2529,
          </p>
          <div
            style={{
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '19px',
            }}
          >
            <p
              style={{
                fontWeight: '700',
                fontSize: '15px',
                marginRight: '5px',
              }}
            >
              Email:
            </p>
            <a href='mailto:contact@2gathers.com' style={{ color: '#556cd6' }}>
              contact@2gathers.com
            </a>
          </div>
        </div>
      </Paper>
    </BodyContainer>
  );
};

export default ContactInfo;
